import { PaginationCount } from '@/entities/todo';
import { ApiError } from '@/services/api';
import { ref } from 'vue';
import { useTask } from '@/ui/concerns/useTask';
import * as TE from 'fp-ts/TaskEither';

interface Response {
  data: unknown[];
  meta: {
    total: number;
    current_page: number;
  };
}

export function useLazyPagination(getPaginationQuery: () => TE.TaskEither<ApiError, PaginationCount>) {
  const total = ref(0);
  const totalLoading = ref(true);
  const isPaginationFetchRequired = ref(true);

  const getPaginationTask = useTask(
    getPaginationQuery,
    paginationResponse => {
      total.value = paginationResponse.data.total;
      totalLoading.value = false;
    },
  );

  const updateLazyPaginationOnDataFetch = (response: Response, perPage: number) => {
    if (total.value === 0) {
      total.value = response.meta.total || response.data.length;

      if (response.meta.current_page === 1 && response.data.length < perPage) {
        total.value = response.data.length;
        isPaginationFetchRequired.value = false;
      }
    }

    if (isPaginationFetchRequired.value) {
      totalLoading.value = true;
      isPaginationFetchRequired.value = false;
      getPaginationTask.run();
    }
  };

  return {
    total,
    totalLoading,
    isPaginationFetchRequired,
    updateLazyPaginationOnDataFetch,
  };
}
